import storage from 'libs/storage'

const DOMAIN = 'AccessToken'

export type AccessToken = {
  accessToken: string
}

export const setAccessToken = ({ accessToken }: AccessToken) => {
  return storage.set(DOMAIN, accessToken)
}

export const getAccessToken = (): AccessToken => {
  const accessToken = storage.get(DOMAIN)
  return { accessToken }
}

export const clearAccessToken = () => {
  return storage.clear(DOMAIN)
}

export const getAuthorizationHeader = () => {
  const { accessToken } = getAccessToken()
  return { Authorization: `Bearer ${accessToken}` }
}
